import { render, staticRenderFns } from "./ClassroomDetailTabs.vue?vue&type=template&id=0db3515d&scoped=true"
import script from "./ClassroomDetailTabs.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabs.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabs.vue?vue&type=style&index=0&id=0db3515d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3515d",
  null
  
)

export default component.exports